import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import ProfilePicture from "Component/Thumbnail/ProfilePicture";
import LinearProgress from "@material-ui/core/LinearProgress";
import Tooltip from "@material-ui/core/Tooltip";
import Drawer from "@material-ui/core/Drawer";
import DrawerHeader from "Component/Headers/drawerHeader";

import { withSnackbar } from "notistack";
import { GetFeature } from "Actions/commonAction";

import timeIcon from "Assets/newicons/notify/hourglass/outline/hourglass-outline-16px.svg";
import userIcon from "Assets/newicons/user/employees/outline/employees-outline-16px.svg";
import { betweenDays } from "Utils/dates";
import DefaultComp from "Component/DefaultComp/Defaultstatecomp";
import emp360 from "Assets/Svg/result360.svg";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import DynamicForm from "Component/DynamicForm";

import Table from "@material-ui/core/Table";

import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import selfReviewImg from "Assets/Svg/self-review-img.svg";
import othersReviewImg from "Assets/Svg/others-review-img.svg";
import React from "react";
import { connect } from "react-redux";
import Link from "@material-ui/core/Link";
import { bindActionCreators } from "redux";
import { getFormattedImageLink } from "Utils";
import LabelIcon from "Component/Labels/LabelIcon";
import InfiniteScroll from "react-infinite-scroll-component";
import DefaultProfileImage from "Assets/Images/profile_defaultImg.svg";
import calendarIcon from "Assets/newicons/user-interface/calendar/outline/calendar-outline-16px.svg";
import designation from "Assets/Icons/Designation/designation-16px.svg";
import { GetNumberOfEmp, getStatus, FormStatus } from "./Functions";
import "./index.scss";
import { getFormattedDate, shortmonths } from "../../../../Utils";

const styles = () => ({
  TableRow: {
    borderRadius: 4,
  },
  customWidth: {
    maxWidth: 300,
    height: "auto",
    maxHeight: "200px !important",
  },
});

class Forms extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Preferences: [],
      hasMore: true,
      expanded: false,
      SelectedEmpData: [],
      selectedempid: null,
      forms: [],
      panel1: false,
      panel2: false,
      statusList: [
        { displayname: "Released", displayvalue: 2 },
        {
          displayname: "Pending Released",
          displayvalue: 5,
        },
      ],
      statusid: 5,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleChange1 = this.handleChange1.bind(this);
    this.handleChange2 = this.handleChange2.bind(this);
  }

  componentDidMount() {}

  handleScroll = () => {
    const { totalcount, forms } = this.props;
    if (forms.length >= totalcount) {
      this.setState({ hasMore: false });
      return;
    }
    setTimeout(() => {
      this.props.getForms();
    }, 500);
  };

  handleExpandClick = (e, panel, id) => {
    console.log("id: ", id);

    this.setState(
      {
        expanded: panel,
        selectedempid: id === 1 ? null : this.state.selectedempid,
        forms: id === 1 ? this.props.forms : [],
      },
      () => {
        if (id === 1) this.props.getForms(null, 1, 2, 1);
      },
    );

    // if (id == 1) {
    //   this.setState(
    //     { expanded: panel, selectedempid: null, forms: this.props.forms },
    //     () => {
    //       // this.props.getForms(null, 1, 1);

    //       this.props.getForms(null, 1, 2);
    //     },
    //   );
    // } else {
    //   // this.props.getForms("", 2, 2);
    //   this.setState({
    //     expanded: panel,
    //     selectedempid: this.state.selectedempid,
    //     forms: this.state.forms,
    //   });
    // }
  };

  handleChange(key, value, data) {
    const empdata = data.find((x) => x.displayvalue == value);
    if (key == "selectedempid") {
      this.setState(
        {
          [key]: value,
          // forms: [],
          // offset: 0,
          // totalcount: 1,
        },
        () => {
          this.props.getForms(empdata, 2, 2, 1);
        },
      );
    }
  }

  handleChange1(key, value, data) {
    const empdata = data.find((x) => x.displayvalue == value);
    if (key == "selectedempid") {
      this.setState(
        {
          [key]: value,
          SelectedEmpData: empdata,
          // forms: [],
          // offset: 0,
          // totalcount: 1,
        },
        () => {
          this.props.getForms(empdata, 2, 2, this.state.statusid);
        },
      );
    }
  }

  handleChange2(key, value, data) {
    // const empdata = data.find((x) => x.displayvalue == value);
    const empdata = data;

    if (key == "statusid") {
      this.setState({ [key]: value }, () => {
        this.props.getForms(empdata, 2, 2, this.state.statusid);
      });
    }
  }

  openParticipantDrawer(arrParticipant = []) {
    this.setState({
      arrParticipant,
      drawerOpen: true,
    });
  }

  render() {
    const {
      // forms,
      selectedcycle,
      isSpecialAccess,
      classes,
      value,
      forms,
      empList,
    } = this.props;

    const SelectedEmpData =
      empList &&
      empList.map((emp) => {
        const data = {};
        data.displayname = emp.fullname;
        data.displayvalue = emp.employeeid;
        return data;
      });

    return (
      <div>
        <Grid container>
          <Grid item md={12} sm={12}>
            {/* <InfiniteScroll
              dataLength={forms.length}
              next={this.handleScroll}
              hasMore={this.state.hasMore}
              more={this.state.hasMore}
              loader={<p></p>}
              height={"78vh"}
              endMessage={
                <p style={{ textAlign: "center" }}>
                  <b>Yay! You have seen it all</b>
                </p>
              }
              className="thin-scroll width100"
              // style={{ maxHeight: "78vh", overflow: "unset" }}
            > */}
            {value == 2 || (value == 1 && isSpecialAccess) ? (
              <InfiniteScroll
                dataLength={forms.length}
                next={this.handleScroll}
                hasMore={this.state.hasMore}
                more={this.state.hasMore}
                loader={<p></p>}
                height={"78vh"}
                endMessage={
                  <p style={{ textAlign: "center" }}>
                    <b>Yay! You have seen it all</b>
                  </p>
                }
                className="thin-scroll width100"
                // style={{ maxHeight: "78vh", overflow: "unset" }}
              >
                <Table style={{ marginTop: 16 }}>
                  <TableHead style={{ background: "#edf5fd" }}>
                    <TableRow>
                      <TableCell>
                        <p className="small-dark-secondary t-bold">
                          Review form name
                        </p>
                      </TableCell>
                      <TableCell>
                        <p className="small-dark-secondary t-bold">
                          Review period
                        </p>
                      </TableCell>
                      <TableCell>
                        <p className="small-dark-secondary t-bold">
                          Participants
                        </p>
                      </TableCell>
                      <TableCell>
                        <p className="small-dark-secondary t-bold">
                          Review date
                        </p>
                      </TableCell>
                      <TableCell>
                        <p className="small-dark-secondary t-bold">
                          Overall performance score
                        </p>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {/* <InfiniteScroll
                  dataLength={forms.length}
                  next={this.handleScroll}
                  hasMore={this.state.hasMore}
                  more={this.state.hasMore}
                  loader={<p></p>}
                  height={"78vh"}
                  endMessage={
                    <p style={{ textAlign: "center" }}>
                      <b>Yay! You have seen it all</b>
                    </p>
                  }
                  className="thin-scroll width100"
                  // style={{ maxHeight: "78vh", overflow: "unset" }}
                > */}
                    {forms &&
                      forms.map((data) => (
                        <TableRow
                          onClick={() =>
                            (isSpecialAccess ||
                              (!isSpecialAccess &&
                                getStatus(data) != FormStatus.CLOSED)) &&
                            this.props.openForm(data)
                          }
                          className="cursor-pointer"
                        >
                          <TableCell>
                            <p className="small-dark-secondary">
                              {data.formtitle}
                            </p>
                          </TableCell>
                          <TableCell>
                            <p className="small-dark-secondary">
                              {data.reviewperiodtypeid == 1
                                ? "Monthly"
                                : data.reviewperiodtypeid == 2
                                ? "Quarterly"
                                : data.reviewperiodtypeid == 3
                                ? "Semi-Annually"
                                : data.reviewperiodtypeid == 4
                                ? "Annually"
                                : " - "}
                            </p>
                          </TableCell>
                          <TableCell>
                            <Grid container>
                              <div
                                className="avtar-thumb-wrapper-small"
                                style={{ height: 32 }}
                              >
                                {data.participant &&
                                data.participant.length > 0 ? (
                                  data.participant.map((emp) => (
                                    <Tooltip
                                      key="key"
                                      title={emp.employeename || emp.fullname}
                                      placement="bottom"
                                      classes={{
                                        tooltip: classes.customWidth,
                                      }}
                                    >
                                      <div
                                        className={
                                          GetNumberOfEmp(
                                            data.participant[0].fullcount,
                                          ) > 0
                                            ? "avtar-thumb-blur"
                                            : "avtar-thumb"
                                        }
                                        style={{
                                          height: 32,
                                          width: 32,
                                          marginLeft: -12,
                                        }}
                                      >
                                        <Link
                                          to={`./profile/${emp.employeeid}`}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          <div
                                            className="avatar-wrapper-small"
                                            style={{ height: 32 }}
                                          >
                                            {emp.imagepath == null ? (
                                              <img
                                                src={DefaultProfileImage}
                                                height="32"
                                                className="team-avatar"
                                              />
                                            ) : (
                                              <img
                                                src={getFormattedImageLink(
                                                  emp.imagepath,
                                                )}
                                                height="32"
                                                className="team-avatar"
                                              />
                                            )}
                                          </div>
                                        </Link>
                                      </div>
                                    </Tooltip>
                                  ))
                                ) : (
                                  <div style={{ marginLeft: -24 }}>
                                    <p
                                      className="small-dark-secondary"
                                      style={{ paddingTop: 6 }}
                                    >
                                      No Employee Assigned
                                    </p>
                                  </div>
                                )}
                              </div>
                              {data.participant &&
                              data.participant.length > 0 ? (
                                GetNumberOfEmp(data.participant[0].fullcount) >
                                0 ? (
                                  <div
                                    className="additional-count"
                                    style={{
                                      marginTop: 3,
                                      height: 32,
                                      width: 32,
                                      marginLeft: -29,
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      this.openParticipantDrawer(
                                        data.participant,
                                      );
                                    }}
                                  >
                                    <span>
                                      <div
                                        className="total-count-small"
                                        style={{ top: 4 }}
                                      >
                                        +
                                        {GetNumberOfEmp(
                                          data.participant[0].fullcount,
                                        )}
                                      </div>
                                    </span>
                                  </div>
                                ) : (
                                  ""
                                )
                              ) : (
                                ""
                              )}
                            </Grid>
                          </TableCell>
                          <TableCell>
                            <p className="small-dark-secondary">
                              {getFormattedDate(data.opendate)}
                            </p>
                          </TableCell>
                          <TableCell>
                            <p className="small-dark-secondary">
                              {data.overallperformancerating
                                ? data.overallperformancerating
                                : "-"}
                            </p>
                          </TableCell>
                        </TableRow>
                      ))}
                    {/* </InfiniteScroll> */}
                  </TableBody>
                </Table>
              </InfiniteScroll>
            ) : (
              <div className="margin-top-16">
                {!isSpecialAccess && (
                  <div>
                    {GetFeature("zero") && (
                      <ExpansionPanel
                        expanded={this.state.expanded === "panel1"}
                        onChange={(e) => {
                          this.handleExpandClick(e, "panel1", 1);
                        }}
                        className="rounded-rectangle-paper rounded-rectangle-div padding0"
                      >
                        <ExpansionPanelSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1bh-content"
                          id="panel1bh-header"
                        >
                          <div
                            className="display-flex width100"
                            style={{
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <div>
                              <div
                                className="display-flex"
                                style={{ alignItems: "center" }}
                              >
                                <p className="normal-dark t-bold margin-right-16">
                                  Self reviews
                                </p>
                                {this.state.expanded === "panel1" &&
                                  this.props.datareceived && (
                                    <span className="rounded-span-count">
                                      {this.props.forms &&
                                        this.props.forms.length}
                                    </span>
                                  )}
                              </div>
                              <p className="small-dark-secondary margin-top-8">
                                Reviews for you, by you
                              </p>
                            </div>
                            <img src={selfReviewImg} height="48"></img>
                          </div>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                          {this.props.forms.length > 0 ? (
                            <InfiniteScroll
                              dataLength={forms.length}
                              next={this.handleScroll}
                              hasMore={this.state.hasMore}
                              more={this.state.hasMore}
                              loader={<p></p>}
                              height={"26vh"}
                              endMessage={
                                <p style={{ textAlign: "center" }}>
                                  <b>Yay! You have seen it all</b>
                                </p>
                              }
                              className="thin-scroll width100"
                              // style={{ maxHeight: "78vh", overflow: "unset" }}
                              style={{ overflowX: "hidden" }}
                            >
                              <Grid container spacing={2}>
                                {this.props.forms &&
                                  this.props.forms.map((data) => (
                                    <Grid
                                      item
                                      md={6}
                                      sm={12}
                                      onClick={() =>
                                        (isSpecialAccess ||
                                          (!isSpecialAccess &&
                                            getStatus(data) !=
                                              FormStatus.CLOSED)) &&
                                        this.props.openForm(data)
                                      }
                                      className={
                                        isSpecialAccess ||
                                        (!isSpecialAccess &&
                                          getStatus(data) != FormStatus.CLOSED)
                                          ? "cursor-pointer"
                                          : ""
                                      }
                                      style={{pointerEvents:data.skippartcipant ? "none" : ""}}
                                    >
                                      <div className="rounded-rectangle-div padding16">
                                       <div className="display-flex" style={{justifyContent:"space-between"}}>
                                        <p className="small-dark t-bold margin-bottom-16">
                                          {data.formtitle}
                                        </p>
                                        {data.skippartcipant &&
                                            <div
                                              className="rounded-rectangle-div"
                                              style={{
                                                padding: "2px 8px",
                                                fontSize: 11,
                                                height: 14,
                                                marginLeft: 16,
                                              }}
                                            >
                                              Skipped participant
                                            </div>
                                            }
                                            </div>

                                        <div
                                          className="display-flex"
                                          style={{
                                            justifyContent: "space-between",
                                          }}
                                        >
                                          <div className="display-flex">
                                            <ProfilePicture
                                              src={getFormattedImageLink(
                                                data.imagepath,
                                              )}
                                              height="24"
                                            />

                                            <span className="small-dark-secondary margin-left-16">
                                              {data.fullname}{" "}
                                            </span>
                                          </div>
                                          {data.reviewperiodtypeid && (
                                            <div className="display-flex">
                                              <span className="margin-right-8">
                                                <LabelIcon
                                                  label={""}
                                                  img={calendarIcon}
                                                />
                                              </span>
                                              <span className="small-dark-secondary">
                                                {data.reviewperiodtypeid == 1
                                                  ? shortmonths[data.openid - 1]
                                                      .name
                                                  : data.reviewperiodtypeid == 2
                                                  ? "Q"
                                                  : data.reviewperiodtypeid == 3
                                                  ? "H"
                                                  : ""}
                                                {data.reviewperiodtypeid != 4
                                                  ? data.reviewperiodtypeid != 1
                                                    ? data.openid
                                                    : ""
                                                  : ""}{" "}
                                                {selectedcycle &&
                                                  selectedcycle.year}
                                              </span>
                                            </div>
                                          )}
                                        </div>
                                        {data.formbar && (
                                          <div className="width100 margin-top-16 margin-bottom-16">
                                            <LinearProgress
                                              variant="determinate"
                                              value={
                                                (parseInt(
                                                  data.formbar.totalfeedback,
                                                ) /
                                                  parseInt(
                                                    data.formbar.totalquestion,
                                                  )) *
                                                100
                                              }
                                            />
                                          </div>
                                        )}

                                        <div
                                          className="display-flex"
                                          style={{
                                            justifyContent: "space-between",
                                          }}
                                        >
                                          <div
                                            className="display-flex margin-bottom-16"
                                            style={{ alignItems: "center" }}
                                          >
                                            <img
                                              src={timeIcon}
                                              alt="icon"
                                              height="16"
                                              className="vertical-middle"
                                            ></img>
                                            {getStatus(data) ==
                                            FormStatus.CLOSED ? (
                                              <span className="extra-small-dark-secondary margin-left-8 small-dark-secondary margin-left-16">
                                                0 days left
                                              </span>
                                            ) : (
                                              <span className="extra-small-dark-secondary margin-left-8 small-dark-secondary margin-left-16">
                                                {`${betweenDays({
                                                  startdate: new Date(),
                                                  enddate: data.closedate,
                                                })} days left`}
                                              </span>
                                            )}
                                          </div>

                                          {data.formbar && (
                                            <span className="small-dark-secondary">
                                              {parseInt(
                                                (parseInt(
                                                  data.formbar.totalfeedback,
                                                ) /
                                                  parseInt(
                                                    data.formbar.totalquestion,
                                                  )) *
                                                  100,
                                              )}
                                              {"%"} complete
                                            </span>
                                          )}
                                        </div>

                                        <div
                                          className="display-flex"
                                          style={{
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                          }}
                                        >
                                          {/* <div
                                          className="display-flex"
                                          style={{
                                            alignItems: "center",
                                            width: "80%",
                                          }}
                                        >
                                          <img
                                            src={userIcon}
                                            className="margin-right-16"
                                          ></img>
                                          <Grid container>
                                            {data.participant &&
                                            data.participant.length > 0 ? (
                                              <Grid
                                                item
                                                md={6}
                                                sm={12}
                                                style={{
                                                  width: "80%",
                                                  display: "flex",
                                                }}
                                              >
                                                <div
                                                  className="avtar-thumb-wrapper-small"
                                                  style={{
                                                    marginLeft: -4,
                                                    height: 24,
                                                  }}
                                                >
                                                  {data.participant &&
                                                  data.participant.length >
                                                    0 ? (
                                                    data.participant.map(
                                                      (emp) => (
                                                        <Tooltip
                                                          key="key"
                                                          title={emp.fullname}
                                                          placement="bottom"
                                                        >
                                                          <div
                                                            className={
                                                              GetNumberOfEmp(
                                                                data
                                                                  .participant[0]
                                                                  .fullcount,
                                                              ) > 0
                                                                ? "avtar-thumb-blur"
                                                                : "avtar-thumb"
                                                            }
                                                            style={{
                                                              height: 24,
                                                              width: 24,
                                                              marginLeft: -4,
                                                            }}
                                                          >
                                                            <Link
                                                              to={`./profile/${emp.employeeid}`}
                                                              target="_blank"
                                                              rel="noopener noreferrer"
                                                            >
                                                              <div
                                                                className="avatar-wrapper-small"
                                                                style={{
                                                                  height: 24,
                                                                }}
                                                              >
                                                                {
                                                                emp.imagepath ==
                                                                  null ? (
                                                                  <img
                                                                    src={
                                                                      DefaultProfileImage
                                                                    }
                                                                    height="24"
                                                                    className="team-avatar"
                                                                  />
                                                                ) : (
                                                                  <img
                                                                    src={getFormattedImageLink(
                                                                      emp.imagepath,
                                                                    )}
                                                                    height="24"
                                                                    className="team-avatar"
                                                                  />
                                                                )}
                                                              </div>
                                                            </Link>
                                                          </div>
                                                        </Tooltip>
                                                      ),
                                                    )
                                                  ) : (
                                                    <div
                                                      style={{
                                                        marginLeft: -24,
                                                      }}
                                                    >

                                                    </div>
                                                  )}
                                                </div>
                                                {data.participant &&
                                                data.participant.length > 0 ? (
                                                  GetNumberOfEmp(
                                                    data.participant[0]
                                                      .fullcount,
                                                  ) > 0 ? (
                                                    <div
                                                      style={{
                                                        marginTop: 3,
                                                        height: 24,
                                                        width: 24,
                                                        marginLeft: 8,
                                                        position: "relative",
                                                      }}
                                                      onClick={(e) =>
                                                        this.props.HelperSliderFlag(
                                                          "right",
                                                          true,
                                                          "360review",
                                                          data,
                                                          e,
                                                        )
                                                      }
                                                    >
                                                      <span>
                                                        <div
                                                          className="total-count-small"
                                                          style={{
                                                            top: 0,
                                                            fontSize: 14,
                                                          }}
                                                        >
                                                          +
                                                          {GetNumberOfEmp(
                                                            data.participant[0]
                                                              .fullcount,
                                                          )}
                                                        </div>
                                                      </span>
                                                    </div>
                                                  ) : (
                                                    ""
                                                  )
                                                ) : (
                                                  ""
                                                )}
                                              </Grid>
                                            ) : (
                                              <span className="small-dark-secondary">
                                                {" "}
                                                No participants
                                              </span>
                                            )}
                                          </Grid>
                                        </div>

                                         */}
                                          {!isSpecialAccess && (
                                            <div>
                                              <p
                                                className="small-dark-secondary t-bold"
                                                style={{
                                                  color:
                                                    getStatus(data) ==
                                                    FormStatus.SUBMIT
                                                      ? "#008985"
                                                      : getStatus(data) ==
                                                        FormStatus.RELEASE
                                                      ? "#A9A9A9"
                                                      : getStatus(data) ==
                                                        FormStatus.OPEN
                                                      ? "#1e8ced"
                                                      : getStatus(data) ==
                                                        FormStatus.OPENDRAFT
                                                      ? "#1e8ced"
                                                      : getStatus(data) ==
                                                        FormStatus.CLOSED
                                                      ? "#ff4052"
                                                      : // : getStatus(data) ==
                                                        //   FormStatus.DUESOON
                                                        // ? "#ad0e46"
                                                        "#ad0e46",
                                                }}
                                              >
                                                {getStatus(data)}
                                              </p>
                                            </div>
                                          )}
                                        </div>
                                        <div className="display-flex margin-top-16">
                                          {data.opendate && (
                                            <p className="small-dark-secondary margin-right-16">
                                              Open date:{" "}
                                              {getFormattedDate(data.opendate)}
                                            </p>
                                          )}
                                          {!isSpecialAccess &&
                                            data.closedate && (
                                              <p className="small-dark-secondary">
                                                Close date:{" "}
                                                {getFormattedDate(
                                                  data.closedate,
                                                )}
                                              </p>
                                            )}
                                        </div>
                                      </div>
                                    </Grid>
                                  ))}
                              </Grid>
                            </InfiniteScroll>
                          ) : (
                            <div
                              style={{ marginTop: -40 }}
                              className="position-rel width100"
                            >
                              {value == 0 && (
                                <DefaultComp
                                  //  text={this.getText()}
                                  heading={"There are no results!"}
                                  subheading="Results will appear once the review forms have been released."
                                  imageSrc={emp360}
                                />
                              )}
                              {value == 1 && (
                                <DefaultComp
                                  //  text={this.getText()}
                                  heading={"There are no results!"}
                                  subheading={
                                    this.state.selectedempid != null
                                      ? "Results will appear once the review forms have been submitted."
                                      : "Please select employee"
                                  }
                                  imageSrc={emp360}
                                />
                              )}
                            </div>
                          )}
                        </ExpansionPanelDetails>
                      </ExpansionPanel>
                    )}
                    {GetFeature("epdegree") && (
                      <ExpansionPanel
                        expanded={this.state.expanded === "panel2"}
                        onChange={(e) => this.handleExpandClick(e, "panel2", 2)}
                        className="rounded-rectangle-paper rounded-rectangle-div padding0 margin-top-16"
                      >
                        <ExpansionPanelSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1bh-content"
                          id="panel1bh-header"
                        >
                          <div
                            className="display-flex width100"
                            style={{
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <div>
                              <div
                                className="display-flex"
                                style={{ alignItems: "center" }}
                              >
                                <p className="normal-dark t-bold margin-right-16">
                                  Other’s reviews
                                </p>
                                {this.state.expanded === "panel2" &&
                                  this.state.selectedempid != null && (
                                    <span className="rounded-span-count">
                                      {this.props.forms &&
                                        this.props.forms.length}
                                    </span>
                                  )}
                              </div>
                              <p className="small-dark-secondary margin-top-8">
                                Reviews for others, by you
                              </p>
                            </div>
                            <img src={othersReviewImg} height="48"></img>
                          </div>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails style={{ display: "block" }}>
                          {!isSpecialAccess && value == 0 && (
                            <span
                              className="inline-block margin-right-8"
                              style={{ width: 240 }}
                            >
                              <DynamicForm
                                fields={selectinputconverter({
                                  value: this.state.selectedempid,
                                  options: SelectedEmpData,
                                  placeholder: "Select employee",
                                  label: "",
                                })}
                                onChange={(id) =>
                                  this.handleChange(
                                    "selectedempid",
                                    id,
                                    SelectedEmpData,
                                  )
                                }
                              />
                            </span>
                          )}
                          {!isSpecialAccess && value == 1 && (
                            <div>
                              <span
                                className="inline-block margin-right-8"
                                style={{ width: 240 }}
                              >
                                <DynamicForm
                                  fields={selectinputconverter({
                                    value: this.state.selectedempid,
                                    options: SelectedEmpData,
                                    placeholder: "Select employee",
                                    label: "Employee",
                                  })}
                                  onChange={(id) =>
                                    this.handleChange1(
                                      "selectedempid",
                                      id,
                                      SelectedEmpData,
                                    )
                                  }
                                />
                              </span>
                              <span
                                className="inline-block margin-right-8"
                                style={{ width: 240 }}
                              >
                                <DynamicForm
                                  fields={selectinputconverter({
                                    value: this.state.statusid,
                                    options: this.state.statusList,
                                    placeholder: "Select status",
                                    label: "Status",
                                  })}
                                  // onChange={(id) =>
                                  //   this.handleChange2("statusid", id)
                                  // }

                                  onChange={(id) =>
                                    this.handleChange2(
                                      "statusid",
                                      id,
                                      this.state.SelectedEmpData,
                                    )
                                  }
                                />
                              </span>
                            </div>
                          )}
                          {this.state.forms.length > 0 ||
                          this.props.forms.length > 0 ? (
                            <InfiniteScroll
                              dataLength={forms.length}
                              next={this.handleScroll}
                              hasMore={this.state.hasMore}
                              more={this.state.hasMore}
                              loader={<p></p>}
                              height={"38vh"}
                              endMessage={
                                <p style={{ textAlign: "center" }}>
                                  <b>Yay! You have seen it all</b>
                                </p>
                              }
                              className="thin-scroll width100"
                              // style={{ maxHeight: "78vh", overflow: "unset" }}
                              style={{ overflowX: "hidden" }}
                            >
                              {!this.state.selectedempid ? (
                                <Grid container spacing={2}>
                                  {this.state.forms &&
                                    this.state.forms.map((data) => (
                                      <Grid
                                        item
                                        md={6}
                                        sm={12}
                                        onClick={() =>
                                          (isSpecialAccess ||
                                            (!isSpecialAccess &&
                                              getStatus(data) !=
                                                FormStatus.CLOSED)) &&
                                          this.props.openForm(data)
                                        }
                                        className={
                                          isSpecialAccess ||
                                          (!isSpecialAccess &&
                                            getStatus(data) !=
                                              FormStatus.CLOSED)
                                            ? "cursor-pointer"
                                            : ""
                                        }
                                        // style={{ float: "left", padding: 8, width: "50%" }}
                                        style={{pointerEvents:data.skippartcipant ? "none" : ""}}
                                      >
                                        <div className="rounded-rectangle-div padding16">
                                        <div className="display-flex" style={{justifyContent:"space-between"}}>
                                          <p className="small-dark t-bold margin-bottom-16">
                                            {data.formtitle}
                                          </p>
                                          {!data.skippartcipant &&
                                            <div
                                              className="rounded-rectangle-div"
                                              style={{
                                                padding: "2px 8px",
                                                fontSize: 11,
                                                height: 14,
                                                marginLeft: 16,
                                              }}
                                            >
                                              Skipped participant
                                            </div>
                                            }
</div>
                                          <div
                                            className="display-flex"
                                            style={{
                                              justifyContent: "space-between",
                                            }}
                                          >
                                            <div className="display-flex">
                                              <ProfilePicture
                                                src={getFormattedImageLink(
                                                  data.imagepath,
                                                )}
                                                height="24"
                                              />

                                              <span className="small-dark-secondary margin-left-16">
                                                {data.fullname}{" "}
                                              </span>
                                            </div>
                                            {data.reviewperiodtypeid && (
                                              <div className="display-flex">
                                                <span className="margin-right-8">
                                                  <LabelIcon
                                                    label={""}
                                                    img={calendarIcon}
                                                  />
                                                </span>
                                                <span className="small-dark-secondary">
                                                  {data.reviewperiodtypeid == 1
                                                    ? shortmonths[
                                                        data.openid - 1
                                                      ].name
                                                    : data.reviewperiodtypeid ==
                                                      2
                                                    ? "Q"
                                                    : data.reviewperiodtypeid ==
                                                      3
                                                    ? "H"
                                                    : ""}
                                                  {data.reviewperiodtypeid != 4
                                                    ? data.reviewperiodtypeid !=
                                                      1
                                                      ? data.openid
                                                      : ""
                                                    : ""}{" "}
                                                  {selectedcycle &&
                                                    selectedcycle.year}
                                                </span>
                                              </div>
                                            )}
                                          </div>
                                          {data.formbar && (
                                            <div className="width100 margin-top-16 margin-bottom-16">
                                              <LinearProgress
                                                variant="determinate"
                                                value={
                                                  (parseInt(
                                                    data.formbar.totalfeedback,
                                                  ) /
                                                    parseInt(
                                                      data.formbar
                                                        .totalquestion,
                                                    )) *
                                                  100
                                                }
                                              />
                                            </div>
                                          )}

                                          <div
                                            className="display-flex"
                                            style={{
                                              justifyContent: "space-between",
                                            }}
                                          >
                                            <div
                                              className="display-flex margin-bottom-16"
                                              style={{ alignItems: "center" }}
                                            >
                                              <img
                                                src={timeIcon}
                                                alt="icon"
                                                height="16"
                                                className="vertical-middle"
                                              ></img>
                                              {getStatus(data) ==
                                              FormStatus.CLOSED ? (
                                                <span className="extra-small-dark-secondary margin-left-8 small-dark-secondary margin-left-16">
                                                  0 days left
                                                </span>
                                              ) : (
                                                <span className="extra-small-dark-secondary margin-left-8 small-dark-secondary margin-left-16">
                                                  {`${betweenDays({
                                                    startdate: new Date(),
                                                    enddate: data.closedate,
                                                  })} days left`}
                                                </span>
                                              )}
                                            </div>

                                            {data.formbar && (
                                              <span className="small-dark-secondary">
                                                {parseInt(
                                                  (parseInt(
                                                    data.formbar.totalfeedback,
                                                  ) /
                                                    parseInt(
                                                      data.formbar
                                                        .totalquestion,
                                                    )) *
                                                    100,
                                                )}
                                                {"%"} complete
                                              </span>
                                            )}
                                          </div>

                                          {!isSpecialAccess && (
                                            <div className="floatright margin-top-16">
                                              <p
                                                className="small-dark-secondary t-bold"
                                                style={{
                                                  color:
                                                    getStatus(data) ==
                                                    FormStatus.SUBMIT
                                                      ? "#008985"
                                                      : getStatus(data) ==
                                                        FormStatus.RELEASE
                                                      ? "#A9A9A9"
                                                      : getStatus(data) ==
                                                        FormStatus.OPEN
                                                      ? "#1e8ced"
                                                      : getStatus(data) ==
                                                        FormStatus.OPENDRAFT
                                                      ? "#1e8ced"
                                                      : getStatus(data) ==
                                                        FormStatus.CLOSED
                                                      ? "#ff4052"
                                                      : // : getStatus(data) ==
                                                        //   FormStatus.DUESOON
                                                        // ? "#ad0e46"
                                                        "#ad0e46",
                                                }}
                                              >
                                                {getStatus(data)}
                                              </p>
                                            </div>
                                          )}

                                          <div
                                            className="display-flex"
                                            style={{
                                              alignItems: "center",
                                              width: "80%",
                                            }}
                                          >
                                            <img
                                              src={userIcon}
                                              className="margin-right-16"
                                            ></img>
                                            <Grid container>
                                              {data.participant &&
                                              data.participant.length > 0 ? (
                                                <Grid
                                                  item
                                                  md={6}
                                                  sm={12}
                                                  style={{
                                                    width: "80%",
                                                    display: "flex",
                                                  }}
                                                >
                                                  <div
                                                    className="avtar-thumb-wrapper-small"
                                                    style={{
                                                      marginLeft: -4,
                                                      height: 24,
                                                    }}
                                                  >
                                                    {data.participant &&
                                                    data.participant.length >
                                                      0 ? (
                                                      data.participant.map(
                                                        (emp) => (
                                                          <Tooltip
                                                            key="key"
                                                            title={emp.fullname}
                                                            placement="bottom"
                                                          >
                                                            <div
                                                              className={
                                                                GetNumberOfEmp(
                                                                  data
                                                                    .participant[0]
                                                                    .fullcount,
                                                                ) > 0
                                                                  ? "avtar-thumb-blur"
                                                                  : "avtar-thumb"
                                                              }
                                                              style={{
                                                                height: 24,
                                                                width: 24,
                                                                marginLeft: -4,
                                                              }}
                                                            >
                                                              <Link
                                                                to={`./profile/${emp.employeeid}`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                              >
                                                                <div
                                                                  className="avatar-wrapper-small"
                                                                  style={{
                                                                    height: 24,
                                                                  }}
                                                                >
                                                                  {emp.imagepath ==
                                                                  null ? (
                                                                    <img
                                                                      src={
                                                                        DefaultProfileImage
                                                                      }
                                                                      height="24"
                                                                      className="team-avatar"
                                                                    />
                                                                  ) : (
                                                                    <img
                                                                      src={getFormattedImageLink(
                                                                        emp.imagepath,
                                                                      )}
                                                                      height="24"
                                                                      className="team-avatar"
                                                                    />
                                                                  )}
                                                                </div>
                                                              </Link>
                                                            </div>
                                                          </Tooltip>
                                                        ),
                                                      )
                                                    ) : (
                                                      <div
                                                        style={{
                                                          marginLeft: -24,
                                                        }}
                                                      >
                                                        {/* <p
                                className="small-dark-secondary"
                                style={{ paddingTop: 14 }}
                              >
                                No Employee Assigned
                              </p> */}
                                                      </div>
                                                    )}
                                                  </div>
                                                  {data.participant &&
                                                  data.participant.length >
                                                    0 ? (
                                                    GetNumberOfEmp(
                                                      data.participant[0]
                                                        .fullcount,
                                                    ) > 0 ? (
                                                      <div
                                                        style={{
                                                          marginTop: 3,
                                                          height: 24,
                                                          width: 24,
                                                          marginLeft: 8,
                                                          position: "relative",
                                                        }}
                                                        onClick={(e) =>
                                                          this.props.HelperSliderFlag(
                                                            "right",
                                                            true,
                                                            "360review",
                                                            data,
                                                            e,
                                                          )
                                                        }
                                                      >
                                                        <span>
                                                          <div
                                                            className="total-count-small"
                                                            style={{
                                                              top: 0,
                                                              fontSize: 14,
                                                            }}
                                                          >
                                                            +
                                                            {GetNumberOfEmp(
                                                              data
                                                                .participant[0]
                                                                .fullcount,
                                                            )}
                                                          </div>
                                                        </span>
                                                      </div>
                                                    ) : (
                                                      ""
                                                    )
                                                  ) : (
                                                    ""
                                                  )}
                                                </Grid>
                                              ) : (
                                                <span className="small-dark-secondary">
                                                  {" "}
                                                  No participants
                                                </span>
                                              )}
                                            </Grid>
                                          </div>

                                          <div className="display-flex margin-top-16">
                                            {data.opendate && (
                                              <p className="input-label margin-right-16">
                                                Open date:{" "}
                                                {getFormattedDate(
                                                  data.opendate,
                                                )}
                                              </p>
                                            )}
                                            {!isSpecialAccess &&
                                              data.closedate && (
                                                <p className="input-label">
                                                  Close date:{" "}
                                                  {getFormattedDate(
                                                    data.closedate,
                                                  )}
                                                </p>
                                              )}
                                          </div>
                                        </div>
                                      </Grid>
                                    ))}
                                </Grid>
                              ) : (
                                <Grid container spacing={2}>
                                  {this.props.forms &&
                                    this.props.forms.map((data) => (
                                      <Grid
                                        item
                                        md={6}
                                        sm={12}
                                        onClick={() =>
                                          (isSpecialAccess ||
                                            (!isSpecialAccess &&
                                              getStatus(data) !=
                                                FormStatus.CLOSED)) &&
                                          this.props.openForm(data)
                                        }
                                        className={
                                          isSpecialAccess ||
                                          (!isSpecialAccess &&
                                            getStatus(data) !=
                                              FormStatus.CLOSED)
                                            ? "cursor-pointer"
                                            : ""
                                        }
                                        style={{pointerEvents:data.skippartcipant ? "none" : ""}}
                                      >
                                        <div className="rounded-rectangle-div padding16">
                                          <div className="display-flex margin-bottom-16" style={{justifyContent:"space-between"}}>
                                            <div className="display-flex" >
                                            <ProfilePicture
                                              src={getFormattedImageLink(
                                                data.imagepath,
                                              )}
                                              height="24"
                                            />

                                            <span className="small-dark-secondary margin-left-16">
                                              {data.fullname}{" "}
                                            </span>
                                            <div
                                              className="rounded-rectangle-div"
                                              style={{
                                                padding: "2px 8px",
                                                fontSize: 11,
                                                height: 14,
                                                marginLeft: 16,
                                              }}
                                            >
                                              {data.participanttypeid == 1
                                                ? "Review as self"
                                                : data.participanttypeid == 2
                                                ? "Review as manager"
                                                : data.participanttypeid == 3
                                                ? "Review as reportee"
                                                : data.participanttypeid == 4
                                                ? "Review as co-worker"
                                                : data.participanttypeid == 5
                                                ? "Review as externals"
                                                : ""}
                                            </div>
                                            </div>
                                            {data.skippartcipant &&
                                            <div
                                              className="rounded-rectangle-div"
                                              style={{
                                                padding: "2px 8px",
                                                fontSize: 11,
                                                height: 14,
                                                marginLeft: 16,
                                              }}
                                            >
                                              Skipped participant
                                            </div>
                                            }
                                          </div>
                                          <div
                                            className="display-flex"
                                            style={{
                                              justifyContent: "space-between",
                                            }}
                                          >
                                            <div className="display-flex">
                                              <p className="small-dark">
                                                {data.formtitle}
                                              </p>
                                            </div>
                                            {data.reviewperiodtypeid && (
                                              <div className="display-flex">
                                                <span className="margin-right-8">
                                                  <LabelIcon
                                                    label={""}
                                                    img={calendarIcon}
                                                  />
                                                </span>
                                                <span className="small-dark-secondary">
                                                  {data.reviewperiodtypeid == 1
                                                    ? shortmonths[
                                                        data.openid - 1
                                                      ].name
                                                    : data.reviewperiodtypeid ==
                                                      2
                                                    ? "Q"
                                                    : data.reviewperiodtypeid ==
                                                      3
                                                    ? "H"
                                                    : ""}
                                                  {data.reviewperiodtypeid != 4
                                                    ? data.reviewperiodtypeid !=
                                                      1
                                                      ? data.openid
                                                      : ""
                                                    : ""}{" "}
                                                  {selectedcycle &&
                                                    selectedcycle.year}
                                                </span>
                                              </div>
                                            )}
                                          </div>
                                          {data.formbar && (
                                            <div className="width100 margin-top-16 margin-bottom-16">
                                              <LinearProgress
                                                variant="determinate"
                                                value={
                                                  (parseInt(
                                                    data.formbar.totalfeedback,
                                                  ) /
                                                    parseInt(
                                                      data.formbar
                                                        .totalquestion,
                                                    )) *
                                                  100
                                                }
                                              />
                                            </div>
                                          )}

                                          <div
                                            className="display-flex"
                                            style={{
                                              justifyContent: "space-between",
                                            }}
                                          >
                                            <div
                                              className="display-flex margin-bottom-16"
                                              style={{ alignItems: "center" }}
                                            >
                                              <img
                                                src={timeIcon}
                                                alt="icon"
                                                height="16"
                                                className="vertical-middle"
                                              ></img>
                                              {getStatus(data) ==
                                              FormStatus.CLOSED ? (
                                                <span className="extra-small-dark-secondary margin-left-8 small-dark-secondary margin-left-16">
                                                  0 days left
                                                </span>
                                              ) : (
                                                <span className="extra-small-dark-secondary margin-left-8 small-dark-secondary margin-left-16">
                                                  {`${betweenDays({
                                                    startdate: new Date(),
                                                    enddate: data.closedate,
                                                  })} days left`}
                                                </span>
                                              )}
                                            </div>

                                            {data.formbar && (
                                              <span className="small-dark-secondary">
                                                {parseInt(
                                                  (parseInt(
                                                    data.formbar.totalfeedback,
                                                  ) /
                                                    parseInt(
                                                      data.formbar
                                                        .totalquestion,
                                                    )) *
                                                    100,
                                                )}
                                                {"%"} complete
                                              </span>
                                            )}
                                          </div>

                                          {/* {!isSpecialAccess && (
                              <div className="floatright margin-top-16">
                                <p
                                  className="small-dark-secondary t-bold"
                                  style={{
                                    color:
                                      getStatus(data) == FormStatus.SUBMIT
                                        ? "#008985"
                                        : getStatus(data) == FormStatus.RELEASE
                                        ? "#A9A9A9"
                                        : getStatus(data) == FormStatus.OPEN
                                        ? "#1e8ced"
                                        : getStatus(data) ==
                                          FormStatus.OPENDRAFT
                                        ? "#1e8ced"
                                        : getStatus(data) == FormStatus.CLOSED
                                        ? "#ff4052"
                                        : getStatus(data) == FormStatus.DUESOON
                                        ? "#ad0e46"
                                        : "#ad0e46",
                                  }}
                                >
                                  {getStatus(data)}
                                </p>
                              </div>
                            )} */}
                                          <div
                                            className="display-flex"
                                            style={{
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                            }}
                                          >
                                            <div
                                              className="display-flex"
                                              style={{
                                                alignItems: "center",
                                                width: "80%",
                                              }}
                                            >
                                              <img
                                                src={userIcon}
                                                className="margin-right-16"
                                              ></img>
                                              <Grid container>
                                                {data.participant &&
                                                data.participant.length > 0 ? (
                                                  <Grid
                                                    item
                                                    md={6}
                                                    sm={12}
                                                    style={{
                                                      width: "80%",
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <div
                                                      className="avtar-thumb-wrapper-small"
                                                      style={{
                                                        marginLeft: -4,
                                                        height: 24,
                                                      }}
                                                    >
                                                      {data.participant &&
                                                      data.participant.length >
                                                        0 ? (
                                                        data.participant.map(
                                                          (emp) => (
                                                            <Tooltip
                                                              key="key"
                                                              title={
                                                                emp.fullname
                                                              }
                                                              placement="bottom"
                                                            >
                                                              <div
                                                                className={
                                                                  GetNumberOfEmp(
                                                                    data
                                                                      .participant[0]
                                                                      .fullcount,
                                                                  ) > 0
                                                                    ? "avtar-thumb-blur"
                                                                    : "avtar-thumb"
                                                                }
                                                                style={{
                                                                  height: 24,
                                                                  width: 24,
                                                                  marginLeft:
                                                                    -4,
                                                                }}
                                                              >
                                                                <Link
                                                                  to={`./profile/${emp.employeeid}`}
                                                                  target="_blank"
                                                                  rel="noopener noreferrer"
                                                                >
                                                                  <div
                                                                    className="avatar-wrapper-small"
                                                                    style={{
                                                                      height: 24,
                                                                    }}
                                                                  >
                                                                    {emp.imagepath ==
                                                                    null ? (
                                                                      <img
                                                                        src={
                                                                          DefaultProfileImage
                                                                        }
                                                                        height="24"
                                                                        className="team-avatar"
                                                                      />
                                                                    ) : (
                                                                      <img
                                                                        src={getFormattedImageLink(
                                                                          emp.imagepath,
                                                                        )}
                                                                        height="24"
                                                                        className="team-avatar"
                                                                      />
                                                                    )}
                                                                  </div>
                                                                </Link>
                                                              </div>
                                                            </Tooltip>
                                                          ),
                                                        )
                                                      ) : (
                                                        <div
                                                          style={{
                                                            marginLeft: -24,
                                                          }}
                                                        >
                                                          {/* <p
                                className="small-dark-secondary"
                                style={{ paddingTop: 14 }}
                              >
                                No Employee Assigned
                              </p> */}
                                                        </div>
                                                      )}
                                                    </div>
                                                    {data.participant &&
                                                    data.participant.length >
                                                      0 ? (
                                                      GetNumberOfEmp(
                                                        data.participant[0]
                                                          .fullcount,
                                                      ) > 0 ? (
                                                        <div
                                                          style={{
                                                            marginTop: 3,
                                                            height: 24,
                                                            width: 24,
                                                            marginLeft: 8,
                                                            position:
                                                              "relative",
                                                          }}
                                                          onClick={(e) =>
                                                            this.props.HelperSliderFlag(
                                                              "right",
                                                              true,
                                                              "360review",
                                                              data,
                                                              e,
                                                            )
                                                          }
                                                        >
                                                          <span>
                                                            <div
                                                              className="total-count-small"
                                                              style={{
                                                                top: 0,
                                                                fontSize: 14,
                                                              }}
                                                            >
                                                              +
                                                              {GetNumberOfEmp(
                                                                data
                                                                  .participant[0]
                                                                  .fullcount,
                                                              )}
                                                            </div>
                                                          </span>
                                                        </div>
                                                      ) : (
                                                        ""
                                                      )
                                                    ) : (
                                                      ""
                                                    )}
                                                  </Grid>
                                                ) : (
                                                  <span className="small-dark-secondary">
                                                    {" "}
                                                    No participants
                                                  </span>
                                                )}
                                              </Grid>
                                            </div>
                                            {!isSpecialAccess && (
                                              <div>
                                                <p
                                                  className="small-dark-secondary t-bold"
                                                  style={{
                                                    color:
                                                      getStatus(data) ==
                                                      FormStatus.SUBMIT
                                                        ? "#008985"
                                                        : getStatus(data) ==
                                                          FormStatus.RELEASE
                                                        ? "#A9A9A9"
                                                        : getStatus(data) ==
                                                          FormStatus.OPEN
                                                        ? "#1e8ced"
                                                        : getStatus(data) ==
                                                          FormStatus.OPENDRAFT
                                                        ? "#1e8ced"
                                                        : getStatus(data) ==
                                                          FormStatus.CLOSED
                                                        ? "#ff4052"
                                                        : // : getStatus(data) ==
                                                          //   FormStatus.DUESOON
                                                          // ? "#ad0e46"
                                                          "#ad0e46",
                                                  }}
                                                >
                                                  {getStatus(data)}
                                                </p>
                                              </div>
                                            )}
                                          </div>
                                          <div className="margin-top-16 display-flex">
                                            {data.opendate && (
                                              <p className="small-dark-secondary margin-right-16">
                                                Open date:{" "}
                                                {getFormattedDate(
                                                  data.opendate,
                                                )}
                                              </p>
                                            )}
                                            {!isSpecialAccess &&
                                              data.closedate && (
                                                <p className="small-dark-secondary">
                                                  Close date:{" "}
                                                  {getFormattedDate(
                                                    data.closedate,
                                                  )}
                                                </p>
                                              )}
                                          </div>
                                        </div>
                                      </Grid>
                                    ))}
                                </Grid>
                              )}
                            </InfiniteScroll>
                          ) : (
                            <div
                              style={{ marginTop: -40 }}
                              className="position-rel width100"
                            >
                              <DefaultComp
                                //  text={this.getText()}
                                heading={"There are no results!"}
                                subheading={
                                  value == 0
                                    ? "Results will appear once the review forms have been released."
                                    : "Results will appear once the review forms have been submitted."
                                }
                                imageSrc={emp360}
                              />
                            </div>
                          )}
                        </ExpansionPanelDetails>
                      </ExpansionPanel>
                    )}
                  </div>
                )}
              </div>
            )}
            {/* </InfiniteScroll> */}
          </Grid>
        </Grid>

        <Drawer
          anchor="right"
          open={this.state.drawerOpen}
          onClose={() =>
            this.setState({
              drawerOpen: false,
              arrParticipant: [],
            })
          }
          classes={{ paper: "width30" }}
        >
          <DrawerHeader
            header="Participants"
            isbackarrow={false}
            closeDrawer={() =>
              this.setState({
                drawerOpen: false,
                arrParticipant: [],
              })
            }
          />
          {this.state.arrParticipant && this.state.arrParticipant.length > 0 ? (
            this.state.arrParticipant.map((participant) => (
              <div className="display-flex employee-list-drawer">
                <div>
                  <ProfilePicture
                    src={getFormattedImageLink(participant.imagepath)}
                    height="36"
                  />
                </div>

                <div className="margin-left-16" style={{ width: "86%" }}>
                  <Tooltip title={participant.fullname} placement="top">
                    <p className="normal-dark-secondary ellipsis width100">
                      {participant.fullname}
                    </p>
                  </Tooltip>
                  <Tooltip title={participant.designationname} placement="top">
                    <div className="margin-top-8 display-flex width100">
                      <img src={designation} className="margin-right-16"></img>
                      <p className="small-dark-secondary width100 ellipsis">
                        {participant.designationname || "-"}
                      </p>
                    </div>
                  </Tooltip>
                </div>
              </div>
            ))
          ) : (
            <p className="normal-dark-secondary text-center">
              No data available
            </p>
          )}
        </Drawer>
      </div>
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(Forms)));
